import { useMemo } from "react";

import { useMachines } from "./use-machines";

interface UseHasNazomiMachineOptions {
	enabled?: boolean;
}

export const useHasNazomiMachine = ({ enabled = true }: UseHasNazomiMachineOptions = {}) => {
	const { machines } = useMachines({
		machineTypes: ["X5"],
		refetchInterval: false,
		enabled,
	});

	const hasNazomiMachine = useMemo(() => {
		if (machines.length === 0) {
			return false;
		}
		return machines.some((machine) => machine.machineType === "X5" && machine.settings.hasEfiPrinter === true);
	}, [machines]);

	return hasNazomiMachine;
};
